import axios from "axios";

axios.defaults.withCredentials = true;

axios.defaults.baseURL = window.location.origin.includes("localhost")
  ? "http://localhost:3037"
  : "https://appeal-api.rustlegends.com";

export default axios;
